import React from "react";
import Dialog from "@material-ui/core/Dialog";
import t from "../../../helpers/t";

const MultipleUsersDialog = ({
  handleCloseMultipleUsersDialog,
  toggleMultipleUsers,
  abonnement,
  multipleUsersList,
}: any) => {
  // get all users in a specifid abonnement
  const abonnements_users = abonnement ? abonnement?.abonnements_users : [];
  const recipientsInfoArr = multipleUsersList ? multipleUsersList : [];
  console.log(abonnement, "abonnement");
  if (abonnements_users !== null && abonnements_users?.length > 0) {
    abonnements_users.map((abonnements_user: any) => {
      recipientsInfoArr.push({
        customer_nbr: abonnements_user.user?.customer_nbr,
        user:
          (abonnements_user.user?.first_name !== undefined
            ? abonnements_user.user.first_name
            : "") +
          " " +
          (abonnements_user.user?.last_name !== undefined ? abonnements_user.user.last_name : ""),
        to: abonnements_user.user?.id,
        cate: abonnements_user.user?.role === "user" ? "user" : "staff",
      });
    });
  }

  return (
    <Dialog
      onClose={handleCloseMultipleUsersDialog}
      aria-labelledby="multiple-recipients-dialog-title"
      open={toggleMultipleUsers}
      // @ts-ignore
      name="multipleRecipientsDialog"
      id="multipleRecipientsDialog"
    >
      <header className="inb-multiple-recipients-header">
        {abonnement ? (
          <a href="#" onClick={handleCloseMultipleUsersDialog}>
            <button
              type="button"
              id="inb-multiple-recipients-dialog-close-button"
              className="button hollow secondary right button-close-multiple-recipients-dialog round"
              title={t("close multiple users dialog")}
            >
              <i className="fi fi-x"></i>
            </button>
          </a>
        ) : (
          <button
            onClick={handleCloseMultipleUsersDialog}
            type="button"
            id="inb-multiple-recipients-dialog-close-button"
            className="button hollow secondary right button-close-multiple-recipients-dialog round"
            title={t("close multiple recipients dialog")}
          >
            <i className="fi fi-x"></i>
          </button>
        )}
        <h4>{t("users", null, "capital")}</h4>
        {recipientsInfoArr.length > 0 && (
          <div id="inb-c-main-header">
            <ul className="inb-tabs row">
              <li className="tabs-title column medium-4">{t("id")}</li>
              <li className="tabs-title column medium-4">{t("user")}</li>
            </ul>
          </div>
        )}
      </header>
      <div
        id="inb-c-main-multiple-recipients"
        className="inb-c-listing off-canvas-content"
        data-off-canvas-content=""
      >
        <>
          {recipientsInfoArr.length > 0 ? (
            recipientsInfoArr.map((recipient: any, index: any) => {
              return (
                <div className="inb-c-item inb-c-item--recipient row" key={index}>
                  <div
                    className="medium-4 small-12 column"
                    title={t("id", null, "capital")}
                    style={{ minWidth: "90px" }}
                  >
                    <span>{recipient.customer_nbr}</span>
                  </div>
                  <div
                    className="medium-4 small-12 column username"
                    title={t("recipient", null, "capital")}
                    style={{ minWidth: "90px" }}
                  >
                    <span>{recipient.user}</span>
                  </div>
                  <div
                    className="medium-4 small-12 column user-profile"
                    title={t("profile", null, "capital")}
                    style={{ minWidth: "90px", cursor: "pointer" }}
                  >
                    <a
                      href={`/users/${recipient.to}?path=/users${recipient.cate === "staff" ? "/staff" : ""}`}
                    >
                      {t("open profile")}
                    </a>
                  </div>
                </div>
              );
            })
          ) : (
            <div className="no-user-item">
              <div className="inb-image-box">
                <img src="assets/img/no-user.png" />
              </div>
              <h3>{t("user not found")}</h3>
              <p>{t("please add user to this abonnement")}</p>
            </div>
          )}
        </>
      </div>
    </Dialog>
  );
};

export default MultipleUsersDialog;
